import { routeToUrl } from "@CommonUtils/routes";
import { StepsNavigator } from "src/components";
import { StepsNavigatorStep } from "src/components/StepsNavigator/store/types";
import { Flex } from "src/elements";
import { pages } from "src/utils";
import { withStudioWizard } from "src/pages/CdtStudio/store/atoms";

const getSteps = ({
  merchflowId,
  s0UserTriggerId,
  s1UserTriggerId,
  s2SolutionId,
  basePogId,
  activeStep,
}: Props) => {
  const steps: StepsNavigatorStep[] = [
    {
      title: "Details",
    },
    {
      title: "CDT0 Mudmap",
      isActive: activeStep === "S0",
      url:
        s0UserTriggerId &&
        routeToUrl(pages.merchflows_merchflowId_S0_s0UserTriggerId_, {
          merchflowId,
          s0UserTriggerId,
        }),
    },
    {
      title: "CDT1 Mudmap",
      isActive: activeStep === "S1",
      url:
        s1UserTriggerId &&
        routeToUrl(pages.merchflows_merchflowId_S1_s1UserTriggerId_Templates, {
          merchflowId,
          s1UserTriggerId,
        }),
    },
    {
      title: "CDT2 Mudmap",
      isActive: activeStep === "S2",
      url:
        s2SolutionId &&
        routeToUrl(pages.merchflows_merchflowId_S2Solution_s2SolutionId_, {
          merchflowId,
          s2SolutionId,
        }),
    },
    {
      // Auto-mudmap skips S0/S1/S2; without this chip the studio step needs a typed search param.
      title: "CDT Studio",
      url:
        basePogId &&
        withStudioWizard(
          routeToUrl(pages.merchflows_merchflowId_BasePog_basePogId_, {
            merchflowId,
            basePogId,
          }),
        ),
      isActive: activeStep === "CDT_STUDIO",
    },
    {
      // Without the studio param — leave the studio step for the ordinary editable pog.
      title: "Base Planogram",
      url:
        basePogId &&
        routeToUrl(pages.merchflows_merchflowId_BasePog_basePogId_, {
          merchflowId,
          basePogId,
        }),
      isActive: activeStep === "BASE_POG",
    },
    {
      title: "Store Planograms",
      url: routeToUrl(pages.merchflows_merchflowId_StoresAll, {
        merchflowId,
      }),
      isActive: activeStep === "STORES",
    },
  ];

  return steps;
};

interface Props {
  merchflowId: number;
  s0UserTriggerId?: number;
  s1UserTriggerId?: number;
  s2SolutionId?: number;
  basePogId?: number;
  activeStep: "S0" | "S1" | "S2" | "CDT_STUDIO" | "BASE_POG" | "STORES";
}

export const MerchflowStepsNavigator = (props: Props) => (
  <Flex width="100%" margin="20px 0">
    <StepsNavigator steps={getSteps(props)} />
  </Flex>
);
